"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainerResultsComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const trainer_types_1 = require("../../types/trainer.types");
const events_1 = require("../../events");
//@ts-ignore                
let rwsTemplate = T.html `<div class="results-section">
  <h2>📊 ${'trainer.results.title'.t()}</h2>
  
  <div class="results-summary">
    <div class="result-card success">
      <h3>✅ ${'trainer.results.success'.t()}</h3>
      <p>${x => 'trainer.results.success.message'.t().replace('{modelName}', x.trainingConfig.modelName)}</p>
    </div>
    
    <div class="final-metrics">
      <h3>${'trainer.results.metrics'.t()}</h3>
      <div class="metrics-grid">
        <div class="metric-card">
          <div class="metric-value">${x => { var _a; return (_a = x.trainingProgress.loss) === null || _a === void 0 ? void 0 : _a.toFixed(4); }}</div>
          <div class="metric-label">${'trainer.results.metric.loss'.t()}</div>
        </div>
        <div class="metric-card">
          <div class="metric-value">${x => { var _a; return (_a = (x.trainingProgress.accuracy * 100)) === null || _a === void 0 ? void 0 : _a.toFixed(1); }}%</div>
          <div class="metric-label">${'trainer.results.metric.accuracy'.t()}</div>
        </div>
        <div class="metric-card">
          <div class="metric-value">${x => x.trainingConfig.epochs}</div>
          <div class="metric-label">${'trainer.results.metric.epochs'.t()}</div>
        </div>
        <div class="metric-card">
          <div class="metric-value">${x => x.dataStatistics.totalSamples}</div>
          <div class="metric-label">${'trainer.results.metric.samples'.t()}</div>
        </div>
      </div>
    </div>
    
    <div class="model-actions">
      <button 
        class="export-button primary-button"
        @click="${x => x.exportModel()}">
        💾 ${'trainer.results.export'.t()}
      </button>
      <button 
        class="deploy-button secondary-button"
        @click="${x => x.deployModel()}">
        🚀 ${'trainer.results.deploy'.t()}
      </button>
      <button 
        class="test-button secondary-button"
        @click="${x => x.testModel()}">
        🧪 ${'trainer.results.test'.t()}
      </button>
    </div>
  </div>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: block;
  width: 100%;
}

.results-section h2 {
  margin: 0 0 2rem 0;
  color: #334155;
}
.results-section .results-summary .result-card {
  padding: 2rem;
  border-radius: 8px;
  margin-bottom: 2rem;
}
.results-section .results-summary .result-card.success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  box-shadow: 0 4px 20px rgba(16, 185, 129, 0.3);
}
.results-section .results-summary .result-card.success h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1.5rem;
}
.results-section .results-summary .result-card.success p {
  margin: 0;
  opacity: 0.9;
}
.results-section .results-summary .final-metrics {
  margin-bottom: 2rem;
}
.results-section .results-summary .final-metrics h3 {
  margin: 0 0 1rem 0;
  color: #334155;
}
.results-section .results-summary .final-metrics .metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}
.results-section .results-summary .final-metrics .metrics-grid .metric-card {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  text-align: center;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.results-section .results-summary .final-metrics .metrics-grid .metric-card .metric-value {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #334155;
}
.results-section .results-summary .final-metrics .metrics-grid .metric-card .metric-label {
  font-size: 0.9rem;
  color: #64748b;
  text-transform: uppercase;
  font-weight: 600;
}
.results-section .results-summary .model-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}
.results-section .results-summary .model-actions button {
  padding: 1rem 2rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.results-section .results-summary .model-actions button.primary-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}
.results-section .results-summary .model-actions button.primary-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}
.results-section .results-summary .model-actions button.secondary-button {
  background: #f1f5f9;
  color: #334155;
  border: 1px solid #e2e8f0;
}
.results-section .results-summary .model-actions button.secondary-button:hover {
  background: #e2e8f0;
  transform: translateY(-2px);
}

.message-container {
  margin-bottom: 1.5rem;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  border-left: 4px solid;
}
.message-container.error {
  background: #fef2f2;
  border-color: #ef4444;
  color: #991b1b;
}
.message-container.error h3 {
  color: #dc2626;
  margin: 0 0 0.5rem 0;
}
.message-container.warning {
  background: #fffbeb;
  border-color: #f59e0b;
  color: #92400e;
}
.message-container.warning h3 {
  color: #d97706;
  margin: 0 0 0.5rem 0;
}
.message-container ul {
  margin: 0;
  padding-left: 1.5rem;
}
.message-container ul li {
  margin-bottom: 0.25rem;
}

@media (max-width: 768px) {
  .results-section .model-actions {
    flex-direction: column;
    align-items: center;
  }
  .results-section .model-actions button {
    width: 100%;
    max-width: 300px;
  }
}`;
const shadowOptions = { "mode": "open" };
let TrainerResultsComponent = class TrainerResultsComponent extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.trainingResults = null;
        this.trainingConfig = null;
        this.parsedData = [];
        this.trainingProgress = null;
        this.dataStatistics = null;
    }
    get hasResults() {
        return this.trainingResults !== null;
    }
    get modelSummary() {
        if (!this.trainingResults || !this.trainingConfig)
            return null;
        return {
            modelName: this.trainingConfig.modelName,
            baseModel: this.trainingConfig.baseModel,
            epochs: this.trainingConfig.epochs,
            finalAccuracy: this.trainingResults.finalAccuracy,
            finalLoss: this.trainingResults.finalLoss,
            trainingTime: this.trainingResults.trainingTime
        };
    }
    get performanceMetrics() {
        if (!this.trainingResults)
            return [];
        return this.trainingResults.metricsHistory.map((metric, index) => ({
            epoch: metric.epoch,
            loss: metric.loss,
            accuracy: metric.accuracy,
            validationLoss: metric.validationLoss || 0,
            validationAccuracy: metric.validationAccuracy || 0
        }));
    }
    exportResults() {
        if (!this.trainingResults || !this.trainingConfig)
            return;
        const exportData = {
            model: this.modelSummary,
            data: this.dataStatistics,
            metrics: this.performanceMetrics,
            config: this.trainingConfig,
            exportedAt: new Date().toISOString()
        };
        const blob = new Blob([JSON.stringify(exportData, null, 2)], {
            type: 'application/json'
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `training-results-${this.trainingConfig.modelName || 'model'}.json`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }
    deployModel() {
        if (!this.trainingResults)
            return;
        this.emit(events_1.trainerEvents.deployModel, {
            modelId: this.trainingResults.modelId,
            config: this.trainingConfig
        });
    }
    testModel() {
        if (!this.trainingResults)
            return;
        this.emit(events_1.trainerEvents.testModel, {
            modelId: this.trainingResults.modelId,
            config: this.trainingConfig
        });
    }
    emit(eventName, detail) {
        this.dispatchEvent(new CustomEvent(eventName, { detail, bubbles: true }));
    }
};
exports.TrainerResultsComponent = TrainerResultsComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof trainer_types_1.TrainingResults !== "undefined" && trainer_types_1.TrainingResults) === "function" ? _a : Object)
], TrainerResultsComponent.prototype, "trainingResults", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof trainer_types_1.TrainingConfig !== "undefined" && trainer_types_1.TrainingConfig) === "function" ? _b : Object)
], TrainerResultsComponent.prototype, "trainingConfig", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TrainerResultsComponent.prototype, "parsedData", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof trainer_types_1.TrainingProgress !== "undefined" && trainer_types_1.TrainingProgress) === "function" ? _c : Object)
], TrainerResultsComponent.prototype, "trainingProgress", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof trainer_types_1.DataStatistics !== "undefined" && trainer_types_1.DataStatistics) === "function" ? _d : Object)
], TrainerResultsComponent.prototype, "dataStatistics", void 0);
exports.TrainerResultsComponent = TrainerResultsComponent = __decorate([
    (0, client_1.RWSView)('trainer-results', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], TrainerResultsComponent);
TrainerResultsComponent.defineComponent();
